import React, { useEffect, useRef, useState } from "react";
import PageLayout from "../../PageLayout/PageLayout";
import classes from "./Photos&Videos.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { Button } from "../../../../../stories/Button/Button";
import {
  AddImageIcon,
  AddImageIconDisabled,
} from "../../../../../constant/imagePath";
import { MasonryMedia } from "../../../../../stories/MasonryMedia/MasonryMedia";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import PhotosAndVideosMobile from "./PhotosAndVideosMobile";

const PhotosAndVideosDesktop = () => {
  const [data, setData] = useState([]);
  const galleryRef = useRef(null);
  return (
    <div className={[classes.PhotosVideosScreen].join(" ")}>
      <Container fluid className={[classes.container, "p-0"].join(" ")}>
        <Row className={[classes.mb52, "g-0"].join(" ")}>
          <Col md={12}>
            <div className={`${classes.edit_heading_main_div}`}>
              <div>
                <h3
                  style={{
                    ...Fonts.h3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Edit Profile
                </h3>
              </div>
              <div className={`${classes.edit_heading_button_div}`}>
                <Button
                  primary={false}
                  size="Medium"
                  customStyle={{
                    padding: "14px 24px",
                    width: "max-content",
                    marginRight: "12px",
                    ...Fonts.b2,
                  }}
                >
                  Profile preview
                </Button>
                <Button
                  primary={true}
                  size="Medium"
                  customStyle={{
                    padding: "14px 24px",
                    width: "max-content",
                    ...Fonts.b2,
                  }}
                >
                  Save changes
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <Row className={[classes.row, "g-0"].join(" ")}>
          <Col md={12}>
            <p
              className={[classes.mb20].join(" ")}
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
            >
              You can upload a maximum of 8 photos or videos
            </p>
            <Button
              className={classes.addImageBtn}
              icon={AddImageIcon}
              size={"Medium"}
              label={"Add photo or video"}
              onClick={() => galleryRef?.current?.click()}
              disabled={data?.length >= 8}
              disabledIcon={AddImageIconDisabled}
            />

            <h6
              style={{ ...Fonts.h9 }}
              className={[classes.mb24, classes.mt32].join(" ")}
            >
              Uploaded{" "}
              <span style={{ color: Colors.mainBlue }}>{data?.length}</span> of
              8 files
            </h6>
            <MasonryMedia galleryData={data} />
            <input
              ref={galleryRef}
              className="d-none"
              type="file"
              accept="video/*, image/*"
              multiple
              onChange={(e) => {
                let newArr = data.slice();

                newArr = [...newArr, ...e.target.files];
                setData(newArr?.slice(0, 8));
              }}
              onClick={(event) => {
                event.target.value = null;
              }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
const PhotosAndVideos = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <PhotosAndVideosMobile /> : <PhotosAndVideosDesktop />;
};
export default PhotosAndVideos;
